export const REQUEST_CUSTOMER_USER_SIGNUP_EMAIL = "REQUEST_CUSTOMER_USER_SIGNUP_EMAIL";
export const REQUEST_EMPLOYEE_SIGNUP_EMAIL = "REQUEST_EMPLOYEE_SIGNUP_EMAIL";
export const REQUEST_SIGNUP_EMAIL_SUCCESS = "REQUEST_SIGNUP_EMAIL_SUCCESS";

export const RESET_CUSTOMER_USER_EMAIL = "RESET_CUSTOMER_USER_EMAIL";

export const RESET_EMPLOYEE_USER_EMAIL = "RESET_EMPLOYEE_USER_EMAIL";

export const RESET_USER_EMAIL_SUCCESS = "RESET_USER_EMAIL_SUCCESS";
